import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface ActivityItem {
  id: string;
  user: string;
  action: string;
  target: string;
  timeAgo: string;
  avatar: string;
  avatarAlt: string;
  dot: string;
}

const activities: ActivityItem[] = [
{
  id: 'act-001', user: 'Amina Wanjiru', action: 'listed a new', target: 'Laptop for sale',
  timeAgo: '3 min', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5c84a8b-1772712488589.png",
  avatarAlt: 'Amina Wanjiru profile photo, young Kenyan woman smiling',
  dot: 'var(--primary)'
},
{
  id: 'act-002', user: 'Brian Otieno', action: 'posted a job at', target: 'KCB Group',
  timeAgo: '8 min', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_107b4af53-1772198985024.png",
  avatarAlt: 'Brian Otieno profile photo, professional Kenyan man in office',
  dot: '#FFB300'
},
{
  id: 'act-003', user: 'Grace Muthoni', action: 'reviewed', target: 'Westgate Hotel',
  timeAgo: '15 min', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5c84a8b-1772712488589.png",
  avatarAlt: 'Grace Muthoni profile photo, Kenyan woman with natural hair',
  dot: '#7C4DFF'
},
{
  id: 'act-004', user: 'James Kamau', action: 'booked a service from', target: 'TechFix Nairobi',
  timeAgo: '22 min', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a715aadc-1763293278128.png",
  avatarAlt: 'James Kamau profile photo, middle-aged Kenyan man in casual wear',
  dot: '#00BCD4'
},
{
  id: 'act-005', user: 'Fatuma Hassan', action: 'uploaded a video', target: '"Nairobi Street Food"',
  timeAgo: '45 min', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5c84a8b-1772712488589.png",
  avatarAlt: 'Fatuma Hassan profile photo, young Kenyan woman in colourful dress',
  dot: '#FF1744'
}];


export default function ActivityFeed() {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-700 text-foreground">Live Activity</h2>
        <span className="flex items-center gap-1.5 text-[10px] font-600 px-2 py-1 rounded-full"
        style={{ background: 'rgba(0,200,83,0.1)', color: 'var(--primary)', border: '1px solid rgba(0,200,83,0.2)' }}>
          <span className="w-1.5 h-1.5 rounded-full animate-pulse-green" style={{ background: 'var(--primary)' }} />
          LIVE
        </span>
      </div>

      <div className="flex flex-col gap-0 rounded-2xl overflow-hidden" style={{ border: '1px solid var(--border)', background: 'var(--card)' }}>
        {activities.map((act) =>
        <div key={act.id} className="flex items-start gap-3 px-4 py-3.5 border-b last:border-b-0 transition-all duration-150 hover:bg-muted/50 cursor-pointer"
        style={{ borderColor: 'var(--border)' }}>
            <div className="relative flex-shrink-0">
              <AppImage src={act.avatar} alt={act.avatarAlt} width={36} height={36}
            className="w-9 h-9 rounded-full object-cover" />
              <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2"
            style={{ background: act.dot, borderColor: 'var(--card)' }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                <span className="font-600 text-foreground">{act.user}</span>{' '}
                {act.action}{' '}
                <span className="font-600" style={{ color: act.dot }}>{act.target}</span>
              </p>
              <p className="text-[10px] mt-0.5" style={{ color: 'var(--muted-foreground)' }}>{act.timeAgo} ago</p>
            </div>
          </div>
        )}
      </div>
    </div>);

}